const h1 = {
  fontSize: '30px',
  lineHeight: '36px',
  letterSpacing: '-0.5px',
  fontWeight: '400'
};

const h2 = {
  fontSize: '24px',
  lineHeight: '32px',
  letterSpacing: '-0.5px',
  fontWeight: '400'
};

const h3 = {
  fontSize: '20px',
  lineHeight: '28px',
  letterSpacing: '-0.5px',
  fontWeight: '400'
};

const subtitle = {
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '-0.5px',
  fontWeight: '400'
};

const body1 = {
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '-0.3px',
  fontWeight: '400'
};

const body2 = {
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: '-0.3px',
  fontWeight: '400'
};

const body3 = {
  fontSize: '10px',
  lineHeight: '8px',
  letterSpacing: '-0.3px',
  fontWeight: '400'
};

export const typography = {
  h1,
  h2,
  h3,
  subtitle,
  body1,
  body2,
  body3
};
